import Repository from "@shared/services/api/abstracts/Repository";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { VenueBaseSpaceSerializer } from "../types/seating-types";

export default class VenueBasedSpaceRepository extends Repository<VenueBaseSpaceSerializer> {
  public readonly repositoryName = "VenueBasedSpaceRepository";

  public readonly endpoint = venueBasedUrl("venues/spaces/");
}
